import { render, staticRenderFns } from "./CopyExistingName.vue?vue&type=template&id=5a97ac22&scoped=true"
import script from "./CopyExistingName.vue?vue&type=script&lang=js"
export * from "./CopyExistingName.vue?vue&type=script&lang=js"
import style0 from "./CopyExistingName.vue?vue&type=style&index=0&id=5a97ac22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a97ac22",
  null
  
)

export default component.exports